import { render, staticRenderFns } from "./iformationEdit.vue?vue&type=template&id=4f4e247b&scoped=true&"
import script from "./iformationEdit.vue?vue&type=script&lang=js&"
export * from "./iformationEdit.vue?vue&type=script&lang=js&"
import style0 from "./iformationEdit.vue?vue&type=style&index=0&id=4f4e247b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e247b",
  null
  
)

export default component.exports